module.exports = __webpack_public_path__ + "js/components/images/dark_insta-2a22148a345fbd259f10ae1d20ba2af9.svg";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/dark_insta.svg
// module id = 823
// module chunks = 31